//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';

import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------


//  -- List books ----------------
export const handleListClassBookmarks = (classId) => async (dispatch) => {
    try {
        let bookmarks = [];
        const bookmarksResp = await apis.get('bookmarks', `/getByClass/${classId}`);
        if (Array.isArray(bookmarksResp) && bookmarksResp.length > 0) {
            bookmarks = bookmarksResp
        }
        await dispatch(ActivityActions.listClassBookmarksSuccess(bookmarks));
        return bookmarks;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing class bookmarks',
                error,
                module: 'BOOKMARK',
                operation: 'LIST_CLASS_BOOK'
            });
        }
        await dispatch(ActivityActions.listClassBookmarksFail(error));
    }
};
export const handleCreateBookmarks = (data) => async (dispatch) => {
    try {
        let bookmarks = {};
        const bookmarksResp = await apis.post('bookmarks', `/bookmark`, {
            body: data
        });
        if (has(bookmarksResp, "id")) {
            bookmarks = bookmarksResp
            await dispatch(ActivityActions.createClassBookmarksSuccess(bookmarks));
        }
        return bookmarks;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating class bookmarks',
                error,
                module: 'BOOKMARK',
                operation: 'CREATE_CLASS_BOOK'
            });
        }
    }
};
export const handleUpdateBookmarks = (id, page) => async (dispatch) => {
    try {
        let bookmarks = {};
        const bookmarksResp = await apis.put('bookmarks', `/bookmark/${id}`, {
            body: { page }
        });
        if (has(bookmarksResp, "id")) {
            bookmarks = bookmarksResp
            await dispatch(ActivityActions.updateClassBookmarks(bookmarks));
        }
        return bookmarks;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating class bookmarks',
                error,
                module: 'BOOKMARK',
                operation: 'UPDATE_CLASS_BOOK'
            });
        }
        await dispatch(ActivityActions.listClassBookmarksFail(error));
    }
};

export const handleDeleteBookmarks = (id) => async (dispatch) => {
    try {
        await apis.del('bookmarks', `/bookmark/${id}`);
        await dispatch(ActivityActions.deleteClassBookmark(id));
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting class bookmarks',
                error,
                module: 'BOOKMARK',
                operation: 'DELETE_CLASS_BOOK'
            });
        }
    }
};
